import styled from "styled-components";
import { Drawer } from 'antd'

export const AppDrawer = styled(Drawer)`
    .ant-drawer-body{
        padding: 0 !important;
    }
`